import React, { useState, useContext, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import { MessageWrapper, StyledButton, Space } from '../css';
import Button from 'components/button';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const StyledTextArea = styled.textarea`
  // to preventiing resize textarea //
  resize: none;
  background-color: ${(props) => props.theme.inputBackground};
  width: 23.945vw;
  border: none;
  color: ${(props) => props.theme.textPrimary};
  padding: ${(props) => (props.focusedProp ? '1.04vw  1.04vw 4vw  1.04vw' : '1.04vw  1.04vw')};
  box-sizing: border-box;
  font-size: 0.832vw;
  border-radius: 0.832vw;
  text-align: left;
  direction: ltr;
  box-shadow: 0 0 0 0.2rem rgba(94, 95, 98, 0);
  overflow: hidden;
  /* transition: padding 200ms ease-in-out; */
  &:active,
  &:focus {
    border: none;
    outline: 0px;
    /* box-shadow: 0 0 0 0.2rem rgb(94,95,98); */
  }
`;

const RelativeDiv = styled.div`
  position: relative;
`;

const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 1vw;
  left: 1.2vw;
  opacity: ${(props) => (props.hide ? '0' : '1')};
  visibility: ${(props) => (props.hide ? 'hidden' : 'visible')};
`;

const Input = (props) => {
  const { theme } = useContext(ThemeContext);
  const textareaRef = useRef(null);
  const [focused, setFocused] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [disableBlurStatus, setDisableBlurStatus] = useState(false);
  const { t } = useTranslation();

  const {
    deletComment,
    editComment,
    message,
    profile,
    name,
    value,
    validate,
    newComment,
    onSaveNewComment,
  } = props;

  useEffect(() => {
    textareaRef.current.style.height = '0px';
    const scrollHeight = textareaRef.current.scrollHeight;
    textareaRef.current.style.height = scrollHeight + 'px';
  }, [value, focused]);

  const onFocus = () => {
    setFocused(true);
  };

  const onBlur = () => {
    if (!disableBlurStatus) {
      setFocused(false);
    }
  };

  const onSaveClick = () => {
    if (newComment) {
      onSaveNewComment();
    } else {
      editComment(message.messageId, message.message);
    }
    setFocused(false);
  };

  const setInputFocused = () => {
    setEditMode(true);
    setTimeout(() => {
      textareaRef.current.focus();
    }, 10);
  };

  const changeBlurStatus = (val) => {
    setDisableBlurStatus(val);
  };

  return (
    <Wrapper>
      <RelativeDiv onBlur={onBlur}>
        <StyledTextArea
          focusedProp={focused}
          onFocus={onFocus}
          ref={textareaRef}
          theme={theme}
          name={name}
          onChange={(event) => {
            props.onChange(props.inputTarget, event.target.value);
          }}
          value={value}
          disabled={!(newComment || editMode)}
          placeholder='Enter your message '
        />
        <ButtonWrapper
          hide={!focused}
          onMouseEnter={() => changeBlurStatus(true)}
          onMouseLeave={() => changeBlurStatus(false)}
        >
          <Button
            onClick={onSaveClick}
            marginTop={0}
            text={t('dashboard.order modal.Save')}
            size="small"
          />
        </ButtonWrapper>
      </RelativeDiv>
      {!newComment && (
        <MessageWrapper marginTop="0.56vw" hide={focused}>
          {profile._id === message.userId && (
            <>
              <Space width="2.55vw" />
              <StyledButton theme={theme} onClick={() => deletComment(message.messageId)}>
                {t('dashboard.order modal.Delete')}
              </StyledButton>
              <Space width="0.676vw" />
              <StyledButton theme={theme} onClick={setInputFocused}>
                {t('dashboard.order modal.Edit')}
              </StyledButton>
            </>
          )}
        </MessageWrapper>
      )}
    </Wrapper>
  );
};

export default Input;
